import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('KeysBalance').create(({ theme }) => ({
  root: {
    width: '100%',
    height: '56px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#111111',
    borderRadius: theme.sizes.radiuses.l,
    border: '1px solid',
    borderColor: theme.colors.borders.default,
    padding: '16px',
  },

  wrapper: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  },

  yourKeysText: {
    color: 'white',
    fontWeight: 450,
    fontSize: theme.sizes.texts.fontSize.m,
  },
  keysAmount: {
    color: theme.colors.text.golden,
    fontWeight: 450,
    fontSize: '20px',
  },
}))
